import { mapState } from 'vuex'
import mascaras from '@/util/mascaras'

export default {
  name: 'contato',
  props: {
    desabilitarCampos: Boolean
  },
  components: {
  },

  computed: {
    ...mapState('escritorios', ['formulario', 'dadosRetorno', 'flagsDeControle'])
  },

  data: () => {
    return {
    }
  },

  methods: {
    mascaraFone (valor) {
      return mascaras.mascaraTelefoneCelular(valor)
    }
  }
}
